import { Component, EventEmitter, Output, SimpleChanges, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import MarkdownIt, { type MarkdownIt as MarkdownItInstance } from 'markdown-it';
import { markdownItTable } from 'markdown-it-table';

// 此component 只能顯示markdown內容，不能編輯markdown內容。編輯用 app-easymde-markdown-editor
@Component({
  selector: 'app-markdown',
  standalone: true,
  imports: [FormsModule, QuillModule, MatTooltipModule],
  //template: '<div [class]="css()" [innerHTML]="renderedContent" ></div>',
  template: '<div [innerHTML]="renderedContent" ></div>',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class MarkdownComponent {
  private sanitizer = inject(DomSanitizer);

  readonly markdownContent = input<string>(`### 卦象 - \n**本卦:** 風地觀 (巽上坤下) -
  **變卦:** 風山漸 (巽上艮下) -
  **互卦:** 天風姤 (乾上巽下) -
  **變爻:** 六四 \n
  ### 本卦：風地觀 (巽上坤下) #### 經文卦意 觀。盥而不薦。有孚顒若。 #### 翼傳注釋 "觀"卦是表示觀察和觀看的意思。觀卦的形象是風在地上吹，意味著觀察和反思。這個卦象提醒人們要仔細觀察周圍的環境和形勢，以便做出明智的決定。 #### 爻辭原文 六四：觀國之光，利用賓于王。`);
  //readonly css = input.required<string>();
  renderedContent: SafeHtml = '';
  private md!: MarkdownItInstance;

  constructor() {
    this.md = new MarkdownIt();
    this.md.use(markdownItTable, {});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['markdownContent']) {
      const rawHtml = this.md.render(this.markdownContent());
      this.renderedContent = this.sanitizer.bypassSecurityTrustHtml(rawHtml);
    }
  }
}
